import React from 'react';

/**
 * Skeleton loader representing the CurrentPlanBanner.
 * Mirrors the exact layout and height of the main banner.
 */
export function CurrentPlanBannerSkeleton() {
  return (
    <div
      style={{
        background: 'var(--admin-card-bg)',
        border: '1px solid var(--admin-card-border)',
        borderRadius: '0',
        padding: '24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '20px',
        height: '110px',
        boxSizing: 'border-box'
      }}
    >
      {/* Left info skeleton */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '200px' }}>
        <div className="admin-skeleton" style={{ height: '24px', width: '70%' }} />
        <div className="admin-skeleton" style={{ height: '14px', width: '100%' }} />
      </div>

      {/* Center bar skeleton */}
      <div style={{ flex: 1, minWidth: '200px', maxWidth: '360px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div className="admin-skeleton" style={{ height: '12px', width: '40%' }} />
          <div className="admin-skeleton" style={{ height: '12px', width: '15%' }} />
        </div>
        <div className="admin-skeleton" style={{ height: '6px', width: '100%', borderRadius: '99px' }} />
        <div className="admin-skeleton" style={{ height: '11px', width: '30%' }} />
      </div>

      {/* Right button skeleton */}
      <div className="admin-skeleton" style={{ height: '40px', width: '140px' }} />
    </div>
  );
}

/**
 * Skeleton loader representing the subscription PlanCards.
 * Renders structured layout shapes mirroring individual card content.
 */
export function PlansSectionSkeleton() {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '16px' }}>
      {[1, 2, 3].map((i) => (
        <div
          key={i}
          style={{
            background: 'var(--admin-card-bg)',
            border: '1px solid var(--admin-card-border)',
            borderRadius: '0',
            padding: '24px',
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            height: '340px',
            boxSizing: 'border-box'
          }}
        >
          {/* Title skeleton */}
          <div className="admin-skeleton" style={{ height: '22px', width: '50%' }} />
          
          {/* Description skeleton */}
          <div className="admin-skeleton" style={{ height: '14px', width: '85%' }} />

          {/* Price skeleton */}
          <div className="admin-skeleton" style={{ height: '36px', width: '40%', marginTop: '8px' }} />

          {/* Badge skeleton */}
          <div className="admin-skeleton" style={{ height: '32px', width: '100%', marginTop: '8px' }} />

          {/* Spacer */}
          <div style={{ flex: 1 }} />

          {/* Button skeleton */}
          <div className="admin-skeleton" style={{ height: '40px', width: '100%' }} />
        </div>
      ))}
    </div>
  );
}

/**
 * Skeleton loader representing the transaction history table view.
 * Renders matching table headers and rows containing cell data placeholders.
 */
export function BillingHistorySkeleton() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            {['Type', 'Reason', 'Credits', 'Balance After', 'Date'].map((h) => (
              <th
                key={h}
                style={{
                  textAlign: 'left',
                  padding: '8px 12px',
                  fontSize: '11px',
                  fontWeight: 700,
                  color: 'var(--admin-card-subtext)',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  borderBottom: '1px solid var(--admin-card-border)',
                }}
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {[1, 2, 3, 4, 5].map((i) => (
            <tr key={i} style={{ borderBottom: '1px solid var(--admin-card-border)' }}>
              <td style={{ padding: '12px' }}>
                <div className="admin-skeleton" style={{ height: '14px', width: '80px' }} />
              </td>
              <td style={{ padding: '12px' }}>
                <div className="admin-skeleton" style={{ height: '14px', width: '120px' }} />
              </td>
              <td style={{ padding: '12px' }}>
                <div className="admin-skeleton" style={{ height: '14px', width: '50px' }} />
              </td>
              <td style={{ padding: '12px' }}>
                <div className="admin-skeleton" style={{ height: '14px', width: '60px' }} />
              </td>
              <td style={{ padding: '12px' }}>
                <div className="admin-skeleton" style={{ height: '14px', width: '100px' }} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
